export enum RequestType {
	ORIGINAL = 'ORIGINAL',
	CANCELLATION = 'CANCELLATION',
}

export interface RequestStatus {
	status: string;
	linkedRequestId?: number;
	requestType?: RequestType;
}
